module.exports = __webpack_public_path__ + "media/images/pc/accessories/men/men_03-37dc531c6efadd9a4f47291410f99c8f.jpg";